import React from 'react';
import "./ContentRecycle.scss";
import name from '../../images/new_ui/name_con.svg'
import uparrow from '../../images/new_ui/uparrow_con.svg'
import size from '../../images/new_ui/size_con.svg'
import date from '../../images/new_ui/date_con.svg'
import filter from '../../images/new_ui/filter_con.svg'
import imgtype from '../../images/new_ui/type_con.svg'
import deletesvg from '../../images/new_ui/deletecontent.svg'

function ContentRecycle() {
    return (
        <div className="Content-recycle">
            <div className="container-fluid">
                <div className="container">
                    <div className="content-list-container">
                        <h5>Recycle Bin</h5>
                        <table stickyHeader aria-label="sticky table">
                            <thead>
                                <tr>
                                    <th>
                                        <img src={name} className="name-icon" />
                                        Name
                                        <img className="uparrow-icon" src={filter} />
                                    </th>
                                    <th>
                                        <img src={size} className="size-icon" />
                                        Size
                                        <img className="uparrow-icon" src={uparrow} />
                                    </th>
                                    <th id="company-filter-icon">
                                        <div>
                                            <img src={imgtype} className="type-icon" />
                                            Type
                                            <img className="filter-icon" src={filter} />
                                        </div>
                                    </th>
                                    <th>
                                        <img src={date} className="date-icon" />
                                        Date
                                        <img className="filter-icon" src={uparrow} />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="invoice-number"></div>
                                    </td>
                                    <td></td>
                                    <td style={{ cursor: "pointer" }}></td>
                                    <td className="Last-Table">
                                        <img className="delete-svg" src={deletesvg} style={{ paddingLeft: '40px', cursor: 'pointer' }} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div style={{ alignContent: "center" }}>
                    {/* Replace TableRight with the appropriate component or element */}
                    {/* <TableRight style={{ width: "300px", height: "auto", cursor: "pointer" }} /> */}
                </div>
            </div>
        </div>
    );
}

export default ContentRecycle;
